import React, { useState } from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ContactSection() {
  const {
    t
  } = useLanguage();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate CRM submission
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 5000);
  };
  return <SectionReveal id="contacto" className="p-0 relative" data-id="element-87" data-mp="3i6ct1alifb84">
      <div className="absolute inset-0 z-0" data-id="element-88" data-mp="347msfkzhetf0">
        <img src="https://images.unsplash.com/photo-1514924013411-cbf25faa35bb?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Atardecer en Tenerife" className="w-full h-full object-cover" data-id="element-89" data-mp="346uzyj16lbsy" />
        <div className="absolute inset-0 bg-navy/80 backdrop-blur-sm" data-id="element-90" data-mp="1suu64ppgmx6c"></div>
      </div>

      <div className="container relative z-10 mx-auto px-6 md:px-12 py-24 lg:py-32" data-id="element-91" data-mp="1wrylgioz6dnd">
        <div className="max-w-3xl mx-auto bg-white rounded-3xl overflow-hidden shadow-2xl p-8 md:p-12" data-id="element-92" data-mp="7mofzbzfuu7s">
          <div className="text-center mb-10" data-id="element-93" data-mp="2owfvuon41si">
            <h2 className="text-4xl font-serif text-navy mb-4" data-id="element-94" data-mp="gnckng2xzi80">
              {t.contact.title}
            </h2>
            <p className="text-gray-600" data-id="element-95" data-mp="ckzqloxk58r2">{t.contact.subtitle}</p>
          </div>

          {isSubmitted ? <div className="flex flex-col items-center justify-center text-center space-y-6 py-12" data-id="element-96" data-mp="qjz729ax2hc5">
              <CheckCircle2 className="w-20 h-20 text-nature" data-id="element-97" data-mp="lkw7h4dph3bk" />
              <h3 className="text-3xl font-serif text-navy" data-id="element-98" data-mp="10akduk0qus65">
                {t.contact.form.successTitle}
              </h3>
              <p className="text-gray-600 text-lg" data-id="element-99" data-mp="vcs9gqiwxdl2">
                {t.contact.form.successDesc}
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-100" data-mp="199ffdisufe34">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-101" data-mp="14dqdh8tcpl3n">
                <div className="space-y-2" data-id="element-102" data-mp="1zj1w6sontjm">
                  <label htmlFor="name" className="text-sm font-medium text-gray-700" data-id="element-103" data-mp="20u6u9xv77cb">
                    {t.contact.form.name} *
                  </label>
                  <input required type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all bg-light/50" placeholder={t.contact.form.namePlaceholder} data-id="element-104" data-mp="axurq6lq6nb0" />
                </div>
                <div className="space-y-2" data-id="element-105" data-mp="ulkaxpfljf8m">
                  <label htmlFor="phone" className="text-sm font-medium text-gray-700" data-id="element-106" data-mp="ypjqa4p5480e">
                    {t.contact.form.phone} *
                  </label>
                  <input required type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all bg-light/50" placeholder={t.contact.form.phonePlaceholder} data-id="element-107" data-mp="30hognbqzqx90" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-108" data-mp="2f7abwsm5gsff">
                <label htmlFor="email" className="text-sm font-medium text-gray-700" data-id="element-109" data-mp="3bvzrgcab18y8">
                  {t.contact.form.email} *
                </label>
                <input required type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all bg-light/50" placeholder={t.contact.form.emailPlaceholder} data-id="element-110" data-mp="32v1pdzjffbia" />
              </div>

              <div className="space-y-2" data-id="element-111" data-mp="1mjegdr8bh6k8">
                <label htmlFor="type" className="text-sm font-medium text-gray-700" data-id="element-112" data-mp="3adhshl0696je">
                  {t.contact.form.typeLabel}
                </label>
                <select id="type" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all bg-light/50" data-id="element-113" data-mp="31e302g0g2lw9">
                  <option value="" data-id="element-114" data-mp="3t24rblrr8zoj">{t.contact.form.typePlaceholder}</option>
                  <option value="apt2" data-id="element-115" data-mp="1xeiv9pi17sf">{t.contact.form.options.apt2}</option>
                  <option value="apt3" data-id="element-116" data-mp="3k2hr33arhzx2">{t.contact.form.options.apt3}</option>
                  <option value="th2" data-id="element-117" data-mp="3p24g09zyd4lp">{t.contact.form.options.th2}</option>
                  <option value="th3" data-id="element-118" data-mp="3p4gw0hm5h4w4">{t.contact.form.options.th3}</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-119" data-mp="2dn7fa2ueoqyi">
                <label htmlFor="message" className="text-sm font-medium text-gray-700" data-id="element-120" data-mp="2dp1zfexusf1j">
                  {t.contact.form.message}
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-navy focus:ring-1 focus:ring-navy outline-none transition-all resize-none bg-light/50" placeholder={t.contact.form.messagePlaceholder} data-id="element-121" data-mp="214btg2dwbg1p"></textarea>
              </div>

              <div className="flex items-start gap-3 pt-2" data-id="element-122" data-mp="1hhxc2dtwtlsk">
                <input required type="checkbox" id="rgpd" className="mt-1 w-4 h-4 text-navy border-gray-300 rounded focus:ring-navy" data-id="element-123" data-mp="1w5iavvjr4yuo" />
                <label htmlFor="rgpd" className="text-sm text-gray-600 leading-tight" data-id="element-124" data-mp="13opfe7qz2040">
                  {t.contact.form.rgpd}
                </label>
              </div>

              <div className="pt-6" data-id="element-125" data-mp="2yrug74qzg4wm">
                <Button type="submit" className="w-full text-lg h-14" size="lg" data-id="element-126" data-mp="2yqt4qz621ged">
                  {t.contact.form.submitBtn}
                </Button>
              </div>
            </form>}
        </div>
      </div>
    </SectionReveal>;
}